import useTranslation from "@/hooks/useTranslation";
import {
  Paper,
  Container,
  Divider,
  ThemeIcon,
  List,
  rem,
  SimpleGrid,
  TextInput,
  Textarea,
  Group,
  Button,
  Title,
  Anchor,
  Text,
  Breadcrumbs,
} from "@mantine/core";
import { IconCheck, IconChevronLeft } from "@tabler/icons";
import { ContactIconsList } from "../components/ContactIcons";
import bg from "../public/bg.svg";
import classes from "../styles/GetInTouch.module.css";
import METATAGSEO from "@/components/metaTagSEO";
import JsonLd from "@/components/JsonLd";
import { siteConfig } from "@/components/seoConfig";
import emailjs from "@emailjs/browser";
import { useForm } from "@mantine/form";
import { useState } from "react";
import Link from "next/link";

export default function contact() {
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);

  const Form = useForm({
    initialValues: {
      CustomerName: "",
      Phone: "",
      Email: "",
      Subject: "",
      ContentMessage: "",
    },
  });

  const seoData = {
    title: "זימון תורים | צור קשר | QuickTor - מערכת לניהול תורים ותשלומים",
    description:
      "נהלו את העסק בקלות עם QuickTor: זימון תורים אונליין, תזכורות בוואטסאפ אוטומטיות, סליקת תשלומים, דף עסקי ממותג וניהול יומנים לכל העובדים. צרו קשר עכשיו!",
    canonicalUrl: `${siteConfig.baseUrl}/contact`,
    keywords:
      "מערכת ניהול תורים, יומן חכם, ניהול תורים, זימון תורים, יומן פגישות, תוכנה לניהול יומן, אפליקציה לניהול תורים",
    isPartOf: "https://quicktor.co.il/",
  };
  // const OgImageUrl =
  //   "/assets/images/2A3/2A3_desk_with_top/2A3_walnut_top_n_chair_white_backround.webp";

  // היומן החכם שמשלב ניהול תורים ויומן לקוחות כזה שנותן לעסק להתנהל חכם

  const BreadcrumbListJson = [
    {
      "@type": "ListItem",
      item: `${siteConfig.baseUrl}/`,
      name: "דף הבית",
      position: 1,
    },
    {
      "@type": "ListItem",
      item: `${siteConfig.baseUrl}/contact`,
      name: "צור קשר",
      position: 2,
    },
  ];

  const items = [
    { title: "דף הבית", href: "/", redirect: true },
    { title: "צור קשר", href: "/about", redirect: false },
  ].map((item, index) => (
    <>
      {item.redirect ? (
        <Anchor component={Link} href={item.href} key={index}>
          {item.title}
        </Anchor>
      ) : (
        <Text>{item.title}</Text>
      )}
    </>
  ));

  const sendEmail = async (formData) => {
    formData.preventDefault();
    try {
      await emailjs.send(
        "service_3tsfpws",
        "template_awkij5s",
        Form.values,

        "6NXMdn4WbMJebcaGG"
      );
      console.log("SUCCESS!");
      setSuccess(true);
    } catch (err) {
      console.log("EMAILJS FAILED...", err);
      return;
    }
  };
  return (
    <Container size={"md"} py={"xl"}>
      <METATAGSEO {...seoData} />
      <JsonLd
        canonical="https://quicktor.co.il/contact"
        title="QuickTor מערכת לניהול תורים"
        description="מערכת לניהול תורים"
        OgImageUrl="/section1.png"
        isPartOf={`https://quicktor.co.il/`}
        BreadcrumbListJson={BreadcrumbListJson}
      />
      <Breadcrumbs my={"sm"} separator={<IconChevronLeft size={14} />}>
        {items}
      </Breadcrumbs>
      <Paper shadow="md" radius="lg">
        <div className={classes.wrapper}>
          <div
            className={classes.contacts}
            style={{ backgroundImage: `url(${bg.src})` }}
          >
            <Title
              order={1}
              fz="xl"
              fw={700}
              className={classes.title}
              c="#fff"
            >
              {t("ContactSection")[0].title}
            </Title>

            <Title
              order={2}
              fz="sm"
              fw={500}
              className={classes.title}
              c="#fff"
            >
              {t("ContactSection")[1].SubTitle}
            </Title>
            <Divider />
            <List
              mt={20}
              spacing="sm"
              size="sm"
              c="#fff"
              icon={
                <ThemeIcon size={20} radius="xl">
                  <IconCheck
                    style={{ width: rem(12), height: rem(12) }}
                    stroke={5.1}
                  />
                </ThemeIcon>
              }
            >
              <List.Item>
                <Title order={6}> {t("ContactSection")[2].label} </Title>
              </List.Item>
              <List.Item>
                <Title order={6}>{t("ContactSection")[3].label}</Title>
              </List.Item>
              <List.Item>
                <Title order={6}>{t("ContactSection")[4].label}</Title>
              </List.Item>
            </List>
            <Divider my={"lg"} />

            <ContactIconsList />
          </div>

          <form className={classes.form} onSubmit={sendEmail}>
            <Title order={3} fz="lg" fw={700} className={classes.title}>
              דברו איתנו
            </Title>

            <div className={classes.fields}>
              <SimpleGrid cols={{ base: 1, sm: 2 }}>
                <TextInput
                  onChange={(e) =>
                    Form.setValues({ CustomerName: e.target.value })
                  }
                  label="שם פרטי"
                  placeholder="דוד..."
                  required
                />
                <TextInput
                  onChange={(e) => Form.setValues({ Email: e.target.value })}
                  label="דוא''ל"
                  placeholder="quicktor@gmail.com"
                  required
                />
              </SimpleGrid>

              <TextInput
                onChange={(e) => Form.setValues({ Phone: e.target.value })}
                label="טלפון"
                required
              />
              <TextInput
                onChange={(e) => Form.setValues({ Subject: e.target.value })}
                mt="md"
                label="נושא"
                placeholder="סליקת לקוח בעת קביעת התור"
                required
              />

              <Textarea
                onChange={(e) =>
                  Form.setValues({ ContentMessage: e.target.value })
                }
                mt="md"
                label="תוכן ההודעה"
                minRows={3}
              />

              <Group justify="flex-end" mt="md">
                <Button type="submit" className={classes.control}>
                  שליחה
                </Button>
                {success && (
                  <p
                    style={{
                      textAlign: "left",
                      color: "green",
                      fontSize: "30px",
                    }}
                  >
                    ההודעה נשלחה בהצלחה 😄
                  </p>
                )}
              </Group>
            </div>
          </form>
        </div>
      </Paper>
    </Container>
  );
}

// התקבלה הודעה חדשה מהאתר

// פרטי הלקוח שהתקבלו :

// שם הלקוח : {{CustomerName}}
// מייל: {{Email}}
// טלפון : {{Phone}}
// נושא : {{Subject}}

// תוכן ההודעה:  {{ContentMeesage}}

// פרטי הלקוח שהתקבלו :
// שם הלקוח : {{CustomerName}}
// מייל: {{Email}}
// טלפון : {{Phone}}
// נושא : {{Subject}}
// תוכן ההודעה:  {{ContentMessage}}
